export const getOfferMappings = (state) => state.offerMappings || [];
export const getStoreMappings = (state) => state.storeMappings || [];
export const getAttractions = (state) => state.attractions || [];
